module.exports = __webpack_public_path__ + "static/15-c10460f56b3244302e6a28ca9d442318.png";